import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/home/:id',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/ProductPage.vue')
  },
  {
    path: '/contact',
    redirect: '/about'
  },
  {
    path: '/document/task/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyView.vue')
  },
  {
    path: '/document/task/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserAgreementView.vue')
  },
  {
    path: '/document/pdfnote/privacy',
    name: 'privacy1',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPDFnote.vue')
  },
  {
    path: '/document/pdfnote/agreement',
    name: 'agreement1',
    component: () => import(/* webpackChunkName: "about" */ '../views/AgreementPDFnote.vue')
  },
  {
    path: '/document/xingshell/privacy',
    name: 'xingshellPrivacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyXingShell.vue')
  },
  {
    path: '/document/xingshell/agreement',
    name: 'xingshellAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/AgreementXingShell.vue')
  },
  {
    path: '/document/archive/privacy',
    name: 'archivePrivacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyArchive.vue')
  },
  {
    path: '/document/archive/agreement',
    name: 'archiveAgreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/AgreementArchive.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
